import axios from 'axios'
import laroute from '~/laroute'

// state
export const state = {
  partners: [],
  customersList: [],
  vendorsList: [],
  partner: {
    name: null,
    payment_term_id: null,
    is_vendor: null,
    is_customer: null,
    is_active: null,
    address: null,
    city: null,
    lookup_payment_term: {},
    postal_code: null,
    phone: null,
    fax: null,
    email: null,
    country_id: null,
    province_id: null,
    contact: null,
    business_no: null,
    credit_limit: null,
    attn: null,
    sales_rep_id: null,
    manager_id: null,
    blankets: []
  },
  filtersData: {
    terms: [],
    provinces: [],
    countries: [],
    contract_statuses: [],
    commissionPaymentOptions: []
  },
  total: 0,
  partnerStore: {},
  storeId: 0
}

// getters
export const getters = {
  partners: state => state.partners,
  total: state => state.total,
  partner: state => state.partner,
  filtersData: state => state.filtersData,
  customersList: state => state.customersList,
  vendorsList: state => state.vendorsList,
  partnerStore: state => state.partnerStore,
  storeId: state => state.storeId
}

// mutations
export const mutations = {
  ADD_PARTNER (state, data) {
    state.partner = data
  },
  PARTNERS (state, data) {
    state.partners = data
  },
  PARTNER (state, data) {
    state.partner = data
  },
  TOTAL (state, data) {
    state.total = data
  },
  FILTERS_DATA (state, data) {
    state.filtersData = data
  },
  CUSTOMERS_LIST (state, data) {
    state.customersList = data
  },
  VENDORS_LIST (state, data) {
    state.vendorsList = data
  },
  PARTNER_STORE (state, data) {
    state.partnerStore = data
  },
  STORE_ID (state, data) {
    state.storeId = data
  }
}

// actions
export const actions = {
  async addPartner ({ commit }, data) {
    const response = await axios.put(laroute.route('create_partner', data))
    commit('ADD_PARTNER', response.data)
  },

  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('partners_filter', filterData))
    commit('PARTNERS', data.items)
    commit('TOTAL', data.total)
  },
  async fetchCustomers ({ commit }) {
    const { data } = await axios.get(laroute.route('customers_list'))
    commit('CUSTOMERS_LIST', data)
  },
  async fetchVendors ({ commit }) {
    const { data } = await axios.get(laroute.route('vendors_list'))
    commit('VENDORS_LIST', data)
  },

  async fetchOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_partner', { id }))
    commit('PARTNER', data)
  },

  async fetchFiltersData ({ commit }) {
    let payload = {
      terms: state.filtersData.terms,
      provinces: state.filtersData.provinces,
      countries: state.filtersData.countries,
      contract_statuses: state.filtersData.contract_statuses,
      commissionPaymentOptions: state.filtersData.commissionPaymentOptions
    }
    if (!state.filtersData.terms.length) {
      const termsResponse = await axios.get(laroute.route('terms_list'))
      payload.terms = termsResponse.data
    }
    if (!state.filtersData.provinces.length) {
      const provincesResponse = await axios.get(laroute.route('get_all_provinces'))
      payload.provinces = provincesResponse.data
    }
    if (!state.filtersData.countries.length) {
      const countriesResponse = await axios.get(laroute.route('countries_list'))
      payload.countries = countriesResponse.data
    }
    if (!state.filtersData.contract_statuses.length) {
      const contractStatusesResponse = await axios.get(laroute.route('contract_statuses_list'))
      payload.contract_statuses = contractStatusesResponse.data
    }

    if (!state.filtersData.commissionPaymentOptions.length) {
      const commissionPaymentOptionsResponse = await axios.get(laroute.route('partner_commission_payment_options'))
      payload.commissionPaymentOptions = commissionPaymentOptionsResponse.data
    }

    commit('FILTERS_DATA', payload)
  },

  async updatePartner ({ commit }) {
    await axios.post(laroute.route('update_partner', {
      id: state.partner.id
    }), state.partner)
  },

  async createShipTo ({ commit }, data) {
    await axios.post(laroute.route('ship_to_create'), data).then((res) => {
      commit('STORE_ID', res.data.data)
    })
  },

  async getPartnerStoreData ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get-partner-store', { id }))
    commit('PARTNER_STORE', data)
  },

  async deletePartnerStore ({ commit }, { id, reason }) {
    await axios.patch(laroute.route('delete_partner_store', { id }), { reason })
  },

  async deletePartner ({ commit }, { id, reason }) {
    await axios.patch(laroute.route('delete_partner', { id }), { reason })
  },

  async updatePartnerStore ({ commit }, { id, data }) {
    await axios.patch(laroute.route('update-partner-store', { id }), { data })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/partners.js